import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import {
	AccountStatementFilter,
	getAccountStatementYearsApi,
} from "api/accounting";
import { getBuyersFilterApi } from "api/common";
import CustomButton from "ui/Button";
import CustomDropDownList from "ui/dropDown";
import { ICON_NAMES } from "utils/constant";

interface Props {
	filterOptions: AccountStatementFilter;
	setFilterOptions: (filter: AccountStatementFilter) => void;
	periods: number[];
	exportAsExcel: () => void;
}

const Filter: FC<Props> = ({
	filterOptions,
	setFilterOptions,
	periods,
	exportAsExcel,
}) => {
	const { t } = useTranslation();
	const [years, setYears] = useState<number[]>([]);

	const handleBuyer = async (buyer: any) => {
		const buyerLedgerAccount = Number(buyer.id || 0);
		const buyerName = buyer.name || buyer.displayName || "";
		if (!buyerLedgerAccount) {
			setYears([]);
			setFilterOptions({
				...filterOptions,
				buyerLedgerAccount,
				buyerName,
			});
			return;
		}

		const response = await getAccountStatementYearsApi(buyerLedgerAccount);
		const availableYears = [...(response.data || [])].sort((a, b) => b - a);
		const year = availableYears[0] ?? filterOptions.year;
		setYears(availableYears);
		setFilterOptions({
			...filterOptions,
			buyerLedgerAccount,
			buyerName,
			year,
		});
	};

	const handleYear = (item: { value: number }) => {
		const year = item.value;
		setFilterOptions({
			...filterOptions,
			year,
		});
	};
	return (
		<div className="filter-container">
			<div className="filter-items">
				<div style={{ width: 250 }}>
					<CustomDropDownList
						data={[]}
						value={{
							id: filterOptions.buyerLedgerAccount || null,
							name: filterOptions.buyerName || " ",
						}}
						dataItemKey="id"
						textField="name"
						label={t("Buyer")}
						defaultItem={{ id: null, name: t("All") }}
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
						onSelect={handleBuyer}
					/>
				</div>

				<div style={{ width: 170 }}>
					<CustomDropDownList
						label={t("Year")}
						data={years.map((year) => ({ value: year, text: String(year) }))}
						value={{
							value: filterOptions.year,
							text: String(filterOptions.year),
						}}
						dataItemKey="value"
						textField="text"
						disabled={!filterOptions.buyerLedgerAccount || years.length === 0}
						serverFilter={false}
						onSelect={handleYear}
					/>
				</div>

				<div style={{ width: 170 }}>
					<CustomDropDownList
						label={t("PeriodFrom")}
						data={periods.map((period) => ({
							value: period,
							text: period,
						}))}
						value={{
							value: filterOptions.monthFrom,
							text: filterOptions.monthFrom,
						}}
						dataItemKey="value"
						textField="text"
						disabled={periods.length === 0}
						serverFilter={false}
						onSelect={(item) =>
							setFilterOptions({
								...filterOptions,
								monthFrom: item.value,
							})
						}
					/>
				</div>
				<div style={{ width: 170 }}>
					<CustomDropDownList
						label={t("PeriodTo")}
						data={periods.map((period) => ({
							value: period,
							text: String(period),
						}))}
						value={{
							value: filterOptions.monthTo,
							text: String(filterOptions.monthTo ?? ""),
						}}
						dataItemKey="value"
						textField="text"
						disabled={periods.length === 0}
						serverFilter={false}
						onSelect={(item) =>
							setFilterOptions({
								...filterOptions,
								monthTo: item.value,
							})
						}
					/>
				</div>
			</div>

			<div className="filter-end-btn">
				<CustomButton
					label="Excel"
					onClick={exportAsExcel}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
